import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { useAlgoliaSearchOptions } from '@backmarket/nuxt-layer-algolia/useAlgoliaSearchOptions'
import {
  type AlgoliaHit,
  algoliaHitToBuybackProduct,
  getBuybackSearchConfiguartion,
} from '@backmarket/nuxt-layer-buyback/composables/buybackSearch/useBuybackSearch'
import algoliasearch from 'algoliasearch'

import { useBuybackCategories } from './useBuybackCategories'

export async function useSeoProductsByCategory(
  category: string,
  brand?: string,
) {
  const algoliaSearchOption = useAlgoliaSearchOptions('buyback')
  const { getTitleByCategory } = useBuybackCategories()

  const {
    data: products,
    pending: isLoading,
    error,
  } = await useAsyncData(
    `seo-products-${category}${brand ? `-${brand}` : ''}`,
    async () => {
      const config = await getBuybackSearchConfiguartion('standard-search')

      if (!config.data.value?.indexName) {
        return []
      }

      const algoliaIndex = algoliasearch(
        'dummy_app_id',
        'dummy_key',
        algoliaSearchOption,
      ).initIndex(config.data.value.indexName)

      const filters = brand
        ? `category:"${category}" AND brand:"${brand}"`
        : `category:"${category}"`

      const searchResult = await algoliaIndex.search<AlgoliaHit>('', {
        filters,
        hitsPerPage: 1000,
      })

      return searchResult.hits.map(algoliaHitToBuybackProduct)
    },
    {
      default: () => [],
    },
  )

  const seoSections = computed(() => ({
    title: getTitleByCategory(brand || category),
    links: products.value.map((p) => ({
      label: p.model,
      url: `/buyback/${p.category}/${p.model}/${p.id}`,
    })),
  }))

  return {
    seoSections,
    isLoading,
    error,
  }
}
